import React, { Component } from 'react';
import { ScreenTitle } from '../../../../components';

import './style.scss';
import { NavLink } from 'react-router-dom';
import { ROUTE_CONSTANTS } from '../../../../shared/constants/Route';
import { withSnackbar } from 'notistack';

class DashboardScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.fetchLeaderboardDetails(
      {
        userId: this.props.userId,
        sessionToken: this.props.sessionToken,
      },
      (message, type) => {
        if (type !== 'success') {
          this.props.enqueueSnackbar(message, {
            variant: type,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        }
      },
    );
  }

  render() {
    return (
      <>
        <ScreenTitle title='Dashboard'/>
        <div className='dashboard'>
          <NavLink to={ROUTE_CONSTANTS.DASHBOARD_SIMULATED_TEST}>
            <div className='dashboard-item'>
              <img
                src={require('../../../../Assets/Images/Icons/simulated.png')}
                alt=''
              />
              <p>Simulated Test Results</p>
            </div>
          </NavLink>
          <NavLink to={ROUTE_CONSTANTS.LEADERBOARD}>
            <div className='dashboard-item'>
              <img
                src={require('../../../../Assets/Images/Icons/leaderboard.png')}
                alt=''
              />
              <p>Leaderboard</p>
            </div>
          </NavLink>
          <NavLink to={ROUTE_CONSTANTS.ACHIEVEMENTS}>
            <div className='dashboard-item'>
              <img
                src={require('../../../../Assets/Images/Icons/achievements.png')}
                alt=''
              />
              <p>Achievements</p>
            </div>
          </NavLink>
          <NavLink to={ROUTE_CONSTANTS.CHANGE_PASSWORD}>
            <div className='dashboard-item'>
              <img
                src={require('../../../../Assets/Images/Icons/change_password.png')}
                alt=''
              />
              <p>Change Password</p>
            </div>
          </NavLink>
          <NavLink to={ROUTE_CONSTANTS.CHALLENGES}>
            <div className='dashboard-item'>
              <img
                src={require('../../../../Assets/Images/Icons/challenges.png')}
                alt=''
              />
              <p>Challenges</p>
            </div>
          </NavLink>
          <NavLink to={ROUTE_CONSTANTS.COURSE_MANUAL}>
            <div className='dashboard-item'>
              <img
                src={require('../../../../Assets/Images/Icons/course_manual.png')}
                alt=''
              />
              <p>Course Manual</p>
            </div>
          </NavLink>
          {this.props.purchaseStatus ? null : (
            <NavLink to={ROUTE_CONSTANTS.PURCHASE_P2P}>
              <div className='dashboard-item'>
                <img
                  src={require('../../../../Assets/Images/Icons/cart.png')}
                  alt=''
                />
                <p>Purchase full P2P Access</p>
              </div>
            </NavLink>
          )}
          <NavLink to={ROUTE_CONSTANTS.TEST_SPEED}>
            <div className='dashboard-item'>
              <img
                src={require('../../../../Assets/Images/Icons/test-speed.png')}
                alt=''
                className='mt-1'
              />
              <p>Test Internet Speed</p>
            </div>
          </NavLink>
          <NavLink to={ROUTE_CONSTANTS.TUTORIAL}>
            <div className='dashboard-item'>
              <img
                src={require('../../../../Assets/Images/Icons/tutorial.png')}
                alt=''
              />
              <p>Tutorial</p>
            </div>
          </NavLink>
        </div>
      </>
    );
  }
}

export default withSnackbar(DashboardScreen);
